import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps';

export default class Header extends React.Component {
  constructor(props) {
    super(props)

    this.config = {
      types : [
        {
          title: 'simple',
          isDefault: true,
        },
      ],
      modifiers : [
        'simpleLight'
      ],
      states : []
    }

  }
  
  render() {
    const { brandSrc, brandAlt, children, ...rest } = this.props
    const props = clearProps(this.props)
    return <header {...rest} className={resolveProps(this.props, this.config, 'Header')} role="banner">
    <div className="mdn-Container">
      <div className="mdn-Header--simple-content">
        <a href={this.props.brandHref || '/'}>
          <img className="mdn-logoSvg" src={brandSrc || (this.props.simpleLight ? 'https://mondrian.claro.com.br/brands/horizontal/default/claro.svg' : 'https://mondrian.claro.com.br/brands/horizontal/inverse/claro.svg')} alt={brandAlt || 'Logotipo da Claro'} />
        </a>
      <div>{children}</div>
      </div>
    </div>
  </header>
  }
}

Header.propTypes = {
  etc : PropTypes.object,
  inverse : PropTypes.bool,
  brandSrc : PropTypes.string,
  brandAlt : PropTypes.string,
  children : PropTypes.node
}